import React, { ReactNode } from 'react';
import { FlexCol, FlexRow } from '../../../../common/components/v2';
import styles from '../../styles.module.scss';

export const TaskDetailsItem = ({
  leftItem,
  rightItem,
}: {
  leftItem: string;
  rightItem: string | ReactNode;
}) => {
  return (
    <>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          {leftItem}
        </FlexCol>
        <FlexCol lg={6} className={styles.TaskInfoCell}>
          {rightItem}
        </FlexCol>
      </FlexRow>
    </>
  );
};
